import React from "react"

const StatsComponent = ({ metrics, nurseStats, maxAcuity, statusCounts }) => {
	// Calculate the counts for each nurse status

	const stats = [
		{
			name: "Nurse with Highest Workload",
			value: metrics.nurseWithHighestWorkload || "N/A",
			acuity: metrics.highestWorkloadAcuity,
			changeType: "positive"
		},
		{
			name: "Nurse with Lowest Workload",
			value: metrics.nurseWithLowestWorkload || "N/A",
			acuity: metrics.lowestWorkloadAcuity,
			changeType: "negative"
		}
	]

	return (
		<div className="bg-gray-900/5 shadow-sm rounded-lg border border-gray-200">
			<div className="mt-1 flex items-center gap-x-1.5">
				<div className="flex items-center space-x-2 m-2">
					<div className="relative flex-none p-1">
						<div className="absolute inset-0 rounded-full bg-emerald-500/20 animate-pulse-ring"></div>
						<div className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
					</div>
					<p className="text-xs leading-5 text-emerald-500">Live - Infusion Center</p>
				</div>
			</div>

			<dl className="grid grid-cols-4 gap-px bg-gray-900/5">
				{/* First Box: Nurse Status Counts */}
				<div
					key="NurseStatus"
					className="flex flex-col bg-white px-4 py-5 sm:px-4 xl:px-6 col-span-2"
				>
					<dt className="text-sm font-medium leading-6 text-gray-500 mb-4">
						Nurse Status
					</dt>
					<dd className="w-full text-xl font-medium leading-6 tracking-tight text-gray-900">
						<div className="flex flex-wrap items-center justify-between space-x-4">
							<div className="inline-flex items-center space-x-2">
								<span>{statusCounts.available}</span>
								<span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-200 text-green-800">
									Available
								</span>
							</div>
							<div className="inline-flex items-center space-x-2">
								<span>{statusCounts.nearCapacity}</span>
								<span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-200 text-yellow-800">
									Near Capacity
								</span>
							</div>
							<div className="inline-flex items-center space-x-2">
								<span>{statusCounts.atCapacity}</span>
								<span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-orange-200 text-orange-800">
									At Capacity
								</span>
							</div>
							<div className="inline-flex items-center space-x-2">
								<span>{statusCounts.overCapacity}</span>
								<span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-200 text-red-800">
									Over Capacity
								</span>
							</div>
						</div>
					</dd>
				</div>

				{/* Second and Third Boxes: As-is Design */}
				{stats.slice(0, 2).map(stat => (
					<div
						key={stat.name}
						className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 bg-white px-4 py-5 sm:px-4 xl:px-6 col-span-1"
					>
						<dt className="text-sm font-medium leading-6 text-gray-500">{stat.name}</dt>
						<dd className="w-full flex-none text-3xl font-medium leading-10 tracking-tight text-gray-900">
							<div>{stat.value}</div>
							{stat.acuity !== null && stat.acuity !== undefined && (
								<div className="text-sm text-gray-500">(Acuity: {stat.acuity})</div>
							)}
						</dd>
					</div>
				))}
			</dl>
		</div>
	)
}

export default StatsComponent
